<template>
    <div class="container-fluid section">
        <div class="row heading">
            <div class="col">
                <h2>Match Commissions</h2>
            </div>

            <div class="col-12 col-lg-9 text-right">
                <button class="btn btn-light" @click="clearFilters"><i class="fa fa-remove"></i> &nbsp;Clear Filters</button>&nbsp;
                <paginate
                        :page-count="num_pages"
                        :initial-page="parseInt(filters.page - 1)"
                        :page-range="1"
                        :margin-pages="1"
                        :click-handler="paginateClick"
                        container-class="pagination"
                        page-class="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                ></paginate>
            </div>
        </div>


        <full-table

                headerClass="table-head"
                filterClass="table-filter table-subhead"
                :cols="cols"
                :data="tableData"
                filterInputClass="form-control"
                :filters="filters"
                @filter="fetch"
        >

            <template slot="actions_heading" scope="props">
                &nbsp;
            </template>

            <template slot="net_billed_data" scope="props">
                {{props.value | formatMoney}}
            </template>
            <template slot="commissions_data" scope="props">
                {{props.value | formatMoney}}
            </template>


            <template slot="net_billed_filter" scope="props">

                <range-filter
                        v-model="filters.search.net_billed"
                        label="$"
                >
                </range-filter>
            </template>

            <template slot="commissions_filter" scope="props">
                <range-filter
                        v-model="filters.search.commissions"
                        label="$"
                >
                </range-filter>
            </template>

            <template slot="matches_data" scope="props">

                <autocomplete
                        :selection="getSelection(props.data)"
                        :list="props.data.matches | getList"
                        @change="setMatch(props.data, $event)"
                        @input="setSearch(props.data, $event)"
                        placeholder="Enter Customer"
                        showempty
                >
                </autocomplete>
            </template>

            <template slot="actions_data" scope="props">
                <div class="btn-group">
                    <button class="btn btn-primary btn-sm" @click="matchAccount(props.data)"><i class="fa fa-link"></i>&nbsp;&nbsp;Match</button>
                    <button class="btn btn-light btn-sm" @click="createAccount(props.data)"></i>Create&nbsp;&nbsp;<i class="fa fa-plus"></i></button>
                </div>
            </template>

            <pulse-loader style="text-align:center;" slot="loading" v-show="loading" color="#5e9cd3"></pulse-loader>

        </full-table>


        <modal v-if="newAccount" size="md" @close="newAccount = false">
            <div slot="header">
                <h3 class="modal-title d-inline d-flex justify-content-start">Add Account</h3>
                <button type="button" class="btn btn-clear close-btn" @click="showAddAccount = false">
                    <i class="fa fa-remove"  />
                </button>
                </h3>
            </div>
            <add-account slot="body" :selected="selected" @close="newAccount = false" @saved="newAccountSaved" ></add-account>
        </modal>

    </div>



</template>
<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import FullTable from '../assets/FullTable.vue';
    import RangeFilter from '../assets/RangeFilter.vue';
    import Autocomplete from '../assets/Autocomplete.vue';
    import AddAccount from '../accounts/AddAccount.vue';
    import AccountUsers from '../accounts/AccountAgents.vue';
    import Modal from '../assets/Modal.vue';
    export default {
        name: "CommissionMatches",
        data: function () {
            return {
                newAccount:false,
                meta: {},
                filters: {
                    search:{
                        carrier_name:'',
                        customer_name:'',
                        account_nmbr:'',
                        net_billed:[null, null],
                        commissions: [null, null],
                        matches:'',
                        user_name: '',
                    },
                    sort: [{
                        field: 'customer_name',
                        dir: 'asc'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                },
                selected:{
                    name: null,
                    carrier_id: '',
                    commission_id: '',
                    status_id: 5,
                    user_id: '',
                    user_name: '',
                    tier: 4
                },
                matches:{

                },
                cols:[
                    {
                        key:        'carrier_name',
                        display:    'Carrier Name',
                        filter:     true,
                        sortable:   true,
                        width:      150,
                        sort:       0
                    },
                    {
                        key:        'customer_name',
                        display:    'CustomerName',
                        filter:     true,
                        sortable:   true,
                        width:      200,
                        sort:       1

                    },
                    {
                        key:        'account_nmbr',
                        display:    'Account Number',
                        filter:     true,
                        sortable:   true,
                        width:      150,
                        sort:       2
                    },
                    {
                        key:        'net_billed',
                        display:    'Net Billed',
                        filter:     "Array",
                        sortable:   true,
                        width:      150,
                        style: {
                            textAlign: 'right'
                        },
                        sort:       3
                    },
                    {
                        key:        'commissions',
                        display:    'Commissions',
                        filter:     "Array",
                        sortable:   true,
                        width:      150,
                        style: {
                            textAlign: 'right'
                        },
                        sort:       4
                    },
                    {
                        key:        'matches',
                        display:    'Matches',
                        filter:     false,
                        sortable:   false,
                        width:      250,
                        sort:       5
                    },
                    {
                        key:        'user_name',
                        display:    'User Name',
                        filter:     true,
                        sortable:   true,
                        width:      150,
                        sort:       6
                    },
                    {
                        key:        'actions',
                        display:    'Actions',
                        filter:     false,
                        sortable:   false,
                        width:      250,
                        sort:       7,
                        style: {
                            textAlign: 'right'
                        },
                    },

                ],
                num_pages: 0,
                tableData:[],
                loading: false
            }
        },
        components: {
            Paginate,
            FullTable,
            PulseLoader,
            Autocomplete,
            RangeFilter,
            AddAccount,
            AccountUsers,
            Modal
        },
        computed:{

        },
        created(){
            this.fetch();
        },
        filters:{
            formatMoney(val){
                if(!val) return ' - ';
                return "$" + parseFloat(val).toFixed(2);
            },
            getList(data){
                if(!data.length) return [];
                var options = data.map(d => { return d.name + ' (' + d.levenshtein + ')'; });
                return options;
            },
        },
        mounted(){
            if(!this.userReport_id && localStorage.getItem('commissionMatchFilters')){
                this.filters = JSON.parse(localStorage.getItem('commissionMatchFilters'));
            }
        },
        methods:{
            getSelection(data){
                if(data.account_name == null){
                    if(!data.matches.length) return '';
                    return data.matches[0].name + ' (' + data.matches[0].levenshtein + ')';
                } else if(data.account_name == '') {
                    return '';
                } else {
                    return data.account_name;
                }

            },
            setSearch(entry, search){

                if(typeof entry.account_name == 'undefined'){
                    this.$set(entry, 'account_name', '');
                    this.$set(entry, 'account_id', '');
                }
                entry.account_name = search;
            },
            setMatch(entry, search){

                if(typeof entry.account_name == 'undefined'){
                    this.$set(entry, 'account_name', '');
                    this.$set(entry, 'account_id', '');
                }

                if(!search) {
                    entry.account_id = '';
                    entry.account_name = '';
                    return;
                }

                var selected = entry.matches.filter(m => {
                    return search.startsWith(m.name);
                });

                if(!selected.length) {
                    entry.account_id = '';
                    entry.account_name = '';
                    return;
                }

                entry.account_id = selected[0].account_id;
                entry.account_name = selected[0].name;

            },
            showDetails(m){

                if(typeof m.showDetails == 'undefined') m.showDetails = false;
                this.$set(m['showDetails'], !m.showDetails);
            },
            paginateClick(pageNum){
                this.filters.page = pageNum;
            },
            fetch: _.debounce(function(filters){

                var _this = this;
                var timeout = {};
                this.tableData = [];

                // data = (filters) ? Object.assign({}, filters) : this.filters;
                this.loading = true;
                var data = JSON.parse(JSON.stringify(this.filters));

                this.timer = moment().valueOf();
                data.time = this.timer;
                data.offset = this.filters.limit * (this.filters.page - 1) || 0;
                data.limit = this.filters.limit;


                this.$send(this, 'commissionMatches',data).then(r => {
                    _this.loading = false;

                    _this.tableData = r.commissionMatches;
                    _this.num_pages = Math.ceil(r.count / _this.filters.limit);
                    _this.meta = Object.assign({}, _this.meta, r.meta);

                    if(!_this.userReport_id){
                        localStorage.setItem('commissionMatchFilters', JSON.stringify(_this.filters));
                    }

                });
            }, 400),
            matchAccount(data){
                var account_id;



                if(!data.account_id){
                    if(data.account_name == null && data.matches.length){
                        account_id = data.matches[0].account_id;
                    } else {

                        return;
                    }
                } else {
                    account_id = data.account_id;
                }

                this.$send(this, 'commissionMatchCreate', {
                    commission_id: data.commission_id,
                    account_id: account_id
                }).then(r => {
                    this.fetch(this.filters);
                });
            },
            createAccount(data){

                this.selected.name = data.customer_name;
                this.selected.carrier_id = data.carrier_id;
                this.selected.commission_id = data.commission_id;
                this.selected.user_id = data.user_id;
                this.selected.user_name = data.user_name;
                this.newAccount = true;
            },
            newAccountSaved(account_id){
                this.newAccount = false;
                this.matchAccount({
                    account_id: account_id,
                    commission_id:this.selected.commission_id
                });
            },
            clearFilters(){
                localStorage.setItem('commissionMatchFilters', '');
                this.resetFilters();
            },
            resetFilters(){
                this.filters = {
                    search:{
                        carrier_name:'',
                        customer_name:'',
                        account_nmbr:'',
                        net_billed:[null, null],
                        commissions: [null, null],
                        matches:'',
                        user_name: '',
                    },
                    sort: [{
                        field: 'customer_name',
                        dir: 'asc'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CommissionMatches.vue?6b9b72f8